import React from 'react';
import {
	ActionWrapper,
	Card,
	Content,
	ContentWrapper,
	Description,
	ReadMore,
	Tag,
	Title,
} from './ArticleCard.styles';

const ArticleCard = ({ title, titleLimited, descriptionLimited, url, tag }) => {
	function toSentenceCase(str) {
		if (!str) return '';
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}
	return (
		<Card>
			<ContentWrapper>
				<Content>
					<Title title={title}>{toSentenceCase(titleLimited)}</Title>
					{/* <Description>{descriptionLimited}</Description> */}
				</Content>
			</ContentWrapper>
			<ActionWrapper>
				<ReadMore href={url} target="_blank">
					Read Article
					<svg
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13 6L18 12L13 18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M6 12H18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</ReadMore>
				<Tag isIndustry={tag === 'Industry'}>{tag}</Tag>
			</ActionWrapper>
		</Card>
	);
};

export default ArticleCard;
